export default {

    namespaced: true,

    state() {
        return {
            permission: [],
            menu: [],
        }
    },

    getters: {

    },

    mutations: {
        setPermission(state, payload) {
            state.permission = payload
        },
        setMenu(state, payload) {
            state.menu = payload
        }
    },

    actions: {

    }

}